export const locale = {
    lang: "ca",
    data: {
        CHARTS: {
            Title: "Gràfics",
            ChartConfiguration: "Configuració del gràfic",
            SeriesConfiguration: "Configuració de sèries",
            Devices: "Dispositius",
            DataPoint: "Dada",
            Series: "Sèries",
            Device: "Dispositiu",
            Actions: "Accions",
            AddSeries: "Afegir sèrie",
            AddButton: "Afegir",
            RemoveButton: "Treure",
            DevicesHint: "Tria un dispositiu del projecte actual.",
            DataPointHint: "Selecciona la mètrica que vols afegir al gràfic, incloent sèries L10/L90.",
            NoProjectSelected: "Selecciona primer un projecte per comparar dades.",
            NoDevicesAvailable: "No hi ha dispositius disponibles al projecte actual.",
            NoSeriesSelected: "Afegeix com a mínim un dispositiu i una dada per mostrar el gràfic.",
            NoChartData: "No hi ha dades disponibles per a la configuració actual.",
        },
    },
};
